export const STORAGE_KEYS = {
  USER: 'user',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  ONBOARDING: 'onboarding',
} as const;

export const ROUTES = {
  HOME: '/LandPage',
  LOGIN: '/login',
  SIGNUP: '/signup',
  TEACHER_SIGNUP: '/cadastro-professor',
  INSTITUTION_SIGNUP: '/cadastro-instituicao',
  ONBOARDING_CHOICE: '/onboarding-choice',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard',
  QUESTIONS: '/questions',
} as const;

export const USER_TYPES = {
  STUDENT: 'student',
  TEACHER: 'teacher',
} as const;
